import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ArrowDropdown, CommentContainer, CommentListContainer, CommentName, CommentShowMore, CommentText, CommentTime } from "../style";
import { Avatar, FlexBox } from "@brg/ui";
import { getCorrectNameFromNumber } from "../../../../../../utilites/getCorrectNameFromNumber";
import { ProfileUtils } from '@brg/auth';
import { useModal } from "../../../../../../core/modules/modal.module";
import { useResizedImage } from "../../../../../cards/CountryViewCard";
import { getFileUrl } from "../../../../../../actions/getFileUrl";
export var HomeworkCommentImage = function (_a) {
    var files = _a.files, onClick = _a.onClick;
    var _b = useResizedImage(files || []), image = _b[0], containerRef = _b[1];
    if (!(image === null || image === void 0 ? void 0 : image.url))
        return null;
    return React.createElement(CommentContainer, { fullWidth: true, ref: containerRef },
        React.createElement("img", { onClick: function () { return onClick && onClick(); }, style: { width: '100%', cursor: 'pointer', objectFit: 'cover' }, src: getFileUrl() + '/' + (image === null || image === void 0 ? void 0 : image.url) || undefined, alt: '' }));
};
//# sourceMappingURL=HomeworkCommentImage.js.mapimport React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ArrowDropdown, CommentContainer, CommentListContainer, CommentName, CommentShowMore, CommentText, CommentTime } from "../style";
import { Avatar, FlexBox } from "@brg/ui";
import { getCorrectNameFromNumber } from "../../../../../../utilites/getCorrectNameFromNumber";
import { ProfileUtils } from '@brg/auth';
import { useModal } from "../../../../../../core/modules/modal.module";
import { useResizedImage } from "../../../../../cards/CountryViewCard";
import { getFileUrl } from "../../../../../../actions/getFileUrl";
export var HomeworkCommentImage = function (_a) {
    var files = _a.files, onClick = _a.onClick;
    var _b = useResizedImage(files || []), image = _b[0], containerRef = _b[1];
    if (!(image === null || image === void 0 ? void 0 : image.url))
        return null;
    return React.createElement(CommentContainer, { fullWidth: true, ref: containerRef },
        React.createElement("img", { onClick: function () { return onClick && onClick(); }, style: { width: '100%', cursor: 'pointer', objectFit: 'cover' }, src: getFileUrl() + '/' + (image === null || image === void 0 ? void 0 : image.url) || undefined, alt: '' }));
};
//# sourceMappingURL=HomeworkCommentImage.js.map